import { Component, Prop, h } from "@stencil/core";

/**
 * @author uis5kor
 * @date 2019-12
 * @licensor Robert Bosch GmbH, 2019
 * @version 1.0.0
 */

@Component({
  tag: "bcp-callout",
})
export class BcpCallout {
  /**
   * type determines if callout is of type success, error or warning
   */
  @Prop() type: "success" | "error" | "warning";

  render() {
    return (
      <div class={`A-Callout A-Callout--${this.type}`}>
        <svg class={`A-Icon A-Icon--${this.type}`} width="25" height="25">
          <use xlinkHref={`#${this.type}`} />
        </svg>
        <div class="A-Callout__inner">
          <slot />
        </div>
      </div>
    );
  }
}
